const values = {
    "NO_ARTICLE_STOCK_TITLE": "No hay artículos en inventario!!!",
}

export default values;